import accountTableTemplate from './reactAdministrationAccountsTable.html';
import { reactAccountCols } from './accountsColDefs';
import { defaultSortModel } from '../../accounts/accountColDefs';
import {ReactTableController} from "../../reactTableController";
import {EXPORT_TYPE} from "../../../export/ExportModalController";
import {BackendService} from "../../../../services/BackendService";
import {ADMINISTRATION_USER_ACC, accounts} from "../../../../services/arsweb/RoutingPaths";
import {ADMINISTRATION_ACCOUNTS_TITLE} from "../../../../services/arsweb/TableTitles";
import { ADDROUTE } from '../../../../views/administration/accounts/AddAccountController';
import { EDITROUTE, EDITTITLE } from '../../../../views/administration/accounts/EditAccountController';

export const DELETEROUTE = 'administration.deleteAccount';
export const DELETETITLE = 'DELETE_ACCOUNTS';
/** @ngInject */
export function reactAdministrationAccountsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: accountTableTemplate,
        controller: ReactAdministratonAccountsTableController,
        controllerAs: 'accountsTableController'
    };
}

/** @ngInject */
export class ReactAdministratonAccountsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, '', new BackendService(userService, ADMINISTRATION_USER_ACC), accounts,
            ADMINISTRATION_ACCOUNTS_TITLE, 'administrationAccountsTableParams', "accountName", true, [], defaultSortModel);
        this.backendService.service.config.params.filter = {};
        this.supportedExports.push(EXPORT_TYPE.PDF_ACCOUNT_OVERVIEW);
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService));
    }

    initGrid(userService) {

        userService.promise.then(()=> {

            // react account columns
            this.colDefs = reactAccountCols(this.translate, userService);
			this.initCols();
            this.globalActions.push( {label: this.translate.instant(DELETETITLE),
                handleAction:() => this.delete(this.gridApi.getSelectedNodes(), DELETEROUTE + 'Confirmation')});
            // react gridParameters for account table
            const accountGridParams = {
                columnDefs: this.colDefs,
                columnMapping: {'currencyCode' : 'currency', "countryName": "country"},
                url: this.backendService.service.getServiceUrl(ADMINISTRATION_USER_ACC + accounts),
                onAdd: () => this.openModalReact(ADDROUTE),
                rowActions: () => { return [{
                        label: this.translate.instant(EDITTITLE),
                        handleAction: (params) => this.openExistingInModal(params.data.accountName, EDITROUTE)
                    }];
                }
            };
            delete this.defaultReactGridParams.onReport;
            this.reactGridParams = {...this.defaultReactGridParams, ...accountGridParams};
        })
    }
}
